import hybridConfig from 'brand/config/hybrid';
import {RouterLocation} from 'coreInterfaces/common/interfaces';
import HybridRoutesMgr from './HybridRoutes';

/**
 * Represents Hybrid Deployment Manager
 */
class HybridDeploymentMgr {
	private HybridPWARoutesMgr: HybridRoutesMgr;
	private HybridExternalRoutesMgr: HybridRoutesMgr;
	private enabled: boolean

	/**
	 * @constructor
	 */
	constructor() {
		this.enabled = hybridConfig?.isEnabled || false;
		this.HybridPWARoutesMgr = new HybridRoutesMgr(hybridConfig?.PWA_ROUTES || []);
		this.HybridExternalRoutesMgr = new HybridRoutesMgr(hybridConfig?.EXTERNAL_ROUTES || []);
	}

	/**
	 * Check if current path should be showed on external host
	 * @param {string} path path
	 * @returns {boolean} is external path
	 */
	private isExternalPath(path: string): boolean {
		return this.HybridExternalRoutesMgr.matchRoute(path) && !this.HybridPWARoutesMgr.matchRoute(path);
	}

	/**
	 * Redirect to external host
	 */
	protected redirectToExternalHost() {
		window && window.location.reload();
	}

	/**
	 * Is Hybrid Deployment enabled
	 * @returns {boolean} is enabled
	 */
	isEnabled() {
		return this.enabled;
	}

	/**
	 * Check if current location should be showed on external host
	 * @param location location
	 * @returns is external location
	 */
	isExternalLocation(location: RouterLocation | Location): boolean {
		return this.isEnabled() && this.isExternalPath(location.pathname + location.search);
	}

	/**
	 * Handle location
	 * @param {RouterLocation} location location
	 * @param {Function | undefined} callback callback function
	 */
	handleLocation(location: RouterLocation | Location, callback: Function | undefined) {
		if (this.isExternalLocation(location)) {
			this.redirectToExternalHost();
			callback && callback();
		}
	}

	/**
	 * Saves the current absolute URL to localStorage.
	 * It will be used in the checkout by the continueShopping function
	 */
	saveCurrentRouteToHistory() {
		if (localStorage) {
			localStorage.setItem('lastPWARoute', window.location.href);
		}
	}
}

export default new HybridDeploymentMgr();
